import React from 'react';

import BodyCopy from 'pubweb-react-components/dist/components/Typography/BodyCopy';
import Heading from 'pubweb-react-components/dist/components/Typography/Heading';

import QuizFormStyles from './QuizForm.styled';
import TemplateForm from '../../TemplateForm';

const QuizForm = ({ ...props }) => {
    return (
        <QuizFormStyles>
            <Heading headingTag="h4" size="small">Enter your information to view your custom results.</Heading>
            <TemplateForm {...props} />
            <div className="legal-footer">
                <BodyCopy paragraphType="small">
                    By clicking submit I accept and agree to <a href="https://www.claytonhomes.com/privacy">Clayton Homes Privacy Practices</a> and understand that my contact information will be used to contact me by telephone and to provide me with marketing communications about Clayton Homes Products and services.
            </BodyCopy>
            </div>
        </QuizFormStyles>);
}

export default QuizForm;